import React from 'react';
import {ReactComponent as CtaBackground} from 'images/dashboard/cta-background.svg';
import classNames from 'classnames';
import './DashboardCTA.styl';

const {format} = new Intl.NumberFormat('en-US');

export default class DashboardCTA extends React.PureComponent {
  render() {
    const {cta, onClick, smallClass} = this.props;
    const count = cta.count;
    const ctaCountScale =
      count < 10 ? 'single-digit' : count < 100 ? 'double-digit' : 'triple-digit-or-more';

    return (
      <div
        className={classNames(['cta-container', smallClass, cta.type.toLowerCase()])}
        onClick={() => (cta.link ? window.open(cta.link) : onClick(cta))}>
        {cta.icon ? (
          <div className={classNames(['icon-wrapper', smallClass])}>
            <cta.icon />
          </div>
        ) : (
          <div className={classNames(['cta-count', ctaCountScale, smallClass])}>
            {format(count)}
          </div>
        )}
        <CtaBackground className={`cta-icon ${smallClass} pointer`} />
        <div className={`cta-label ${smallClass}`}>{cta.label}</div>
      </div>
    );
  }
}
